import { Draggable } from "@hello-pangea/dnd";
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import AutorenewIcon from '@mui/icons-material/Autorenew';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LockOutlineIcon from '@mui/icons-material/LockOutline';
// import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { Autocomplete,Badge,Box,Button,Checkbox,Stack,TextField,Tooltip,Typography,useTheme } from "@mui/material";
import { blue } from "@mui/material/colors";
// import { alpha } from "@mui/material/styles";
import { DesktopDatePicker,LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useMutation } from "@tanstack/react-query";
// import { formatDistance } from "date-fns";
import { ptBR } from "date-fns/locale";
import React,{ useState } from "react";
import { useTranslation } from "react-i18next";
import AttToken from "../../helpers/attToken";
import Unity from "../../service/Unity";
import { FluxoState } from "../../types/fluxo/types";

const unityService = new Unity();

type cardProps = {
  nomeFormulario: string;
  handleCancelEdit: (id: string) => void;
  droppableId: string | undefined;
  isEditing: boolean;
  updateFirestore: (id: string, droppableId: string, selectedUnidade: string | null, date: number | null) => void;
  execucao: FluxoState;
  index: number;
  isSelected: boolean;
  toggleSelection: (id: string, multiSelect?: boolean) => void;
  selectedCount: number;
  isSaving?: boolean;
  isError?: boolean;
};

const AccomplishCard = ({ nomeFormulario, handleCancelEdit, droppableId, isEditing, updateFirestore, execucao,
  index, isSelected, toggleSelection, selectedCount, isSaving, isError }: cardProps) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation('translation');
  const [selectedUnidade, setSelectedUnidade] = useState<string | null>(execucao.idUnidade || null);
  const [date, setDate] = useState<Date | null | undefined>(execucao.dataPrevista ? new Date(execucao.dataPrevista) : null);

  const isDragDisabled = (status: string) => {
    return status === 'em_execucao' || status === 'pausado';
  };

/*   const dateLocale = i18n.resolvedLanguage === 'en'
    ? enUS
    : i18n.resolvedLanguage === 'es'
      ? es
      : ptBR; */

  const { data: unidadesData, mutate: getUnidades } = useMutation({
    mutationKey: ['GET_UNIDADES'],
    mutationFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await unityService.getUnitsByFormId(token, droppableId || '');
        return response.unidades;
      }
    }
  });

/*   const renderStatus = (status: string, dataPrevista?: number) => {
    const isAtrasado = status === "pendente" && dataPrevista && Date.now() > dataPrevista;
    const time = dataPrevista ? formatDistance(new Date(dataPrevista), new Date(), { locale: dateLocale, addSuffix: true }) : '';

    let stat = { icon: <AccessTimeIcon fontSize='small' />, color: theme.palette.grey[100], text: time };

    if (isAtrasado) {
      stat = { icon: <ErrorOutlineIcon fontSize='small' />, color: alpha(theme.palette.warning.main, 0.18), text: time };
    } else if (status === "em_execucao") {
      stat = { icon: <AutorenewIcon fontSize='small' />, color: alpha(theme.palette.success.light, 0.18), text: t('fluxo.status.in_progress') };
    } else if (status === "pausado") {
      stat = { icon: <PauseCircleOutlineIcon fontSize='small' />, color: alpha(theme.palette.info.main, 0.18), text: t('fluxo.status.paused') };
    }

    return <Chip icon={stat.icon} label={stat.text} sx={{ bgcolor: stat.color, borderRadius: 1 }} />;
  }; */

  const renderLockIcon = (status: string) => {
    if (isDragDisabled(status)) {
      return <Tooltip title={t('fluxo.locked')}>
        <span>
          <LockOutlineIcon className="lockIcon" sx={{ position: 'absolute', right: 12, top: 12, opacity: 0, transition: 'opacity 0.2s' }} fontSize="small" color="disabled" />
        </span>
      </Tooltip>;
    }
    return <Checkbox onChange={() => toggleSelection(execucao.id, true)} onClick={(e) => e.stopPropagation()} checked={isSelected} size="small" className="lockIcon" sx={{ '&.Mui-checked': { opacity: 1 }, position: 'absolute', right: 6, top: 6, opacity: 0, transition: 'opacity 0.2s' }} />;
  };

  const primeiroValor = (...valores: Array<string | null | undefined>) => valores.find((valor) => valor?.trim());
  const dataPrevista = execucao.dataPrevista ? new Date(execucao.dataPrevista) : null;
  const dataPrevistaFormatada = dataPrevista && !Number.isNaN(dataPrevista.getTime())
    ? dataPrevista.toLocaleString(i18n.language)
    : undefined;
  const detalhes = [
    ['Agendamento', primeiroValor(execucao.nomeAgendamento, execucao.agendamento)],
    ['', execucao.resumoAgendamento?.subtitulo],
    ['Identificador', execucao.identificadorAgendamento ?? execucao.identificador],
    ['Formulário', primeiroValor(execucao.nomeFormulario, execucao.formulario, nomeFormulario)],
    ['Outro nome qualquer', primeiroValor(execucao.nomeOutro, execucao.outroNome)],
    ['Local', primeiroValor(execucao.nomeLocal, execucao.local)],
    ['Conjunto', primeiroValor(execucao.nomeConjunto, execucao.conjunto)],
    ['Data prevista', dataPrevistaFormatada],
  ].filter(([, valor]) => Boolean(valor));

  return (
    <Draggable key={execucao.id} draggableId={execucao.id} index={index} isDragDisabled={isDragDisabled(execucao.status)}>
      {(provided) => (
        <Box ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          marginBottom={1}
          bgcolor={isSelected ? blue[50] : theme.palette.common.white}
          borderRadius={2}
          border={2}
          borderColor={isError ? theme.palette.error.main : isSelected ? theme.palette.info.main : 'transparent'}
          position={'relative'}
          sx={{ '&:hover .lockIcon': { opacity: 1 }, '&:hover': { boxShadow: '0px 5px 10px rgba(0,0,0,0.1)' } }}>
          <Box onClick={(e) => isDragDisabled(execucao.status) ? undefined : toggleSelection(execucao.id, e.ctrlKey || e.metaKey)} padding={1.5}>
            <Badge badgeContent={selectedCount > 1 ? selectedCount : 0} color="primary" sx={{ '& .MuiBadge-badge': { borderRadius: 999, height: 24, width: 24, fontSize: '1rem', fontWeight: 'bold' }, position: 'absolute', top: -6, right: -6 }} />
            {renderLockIcon(execucao.status)}
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1} paddingRight={3} marginBottom={1}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ wordBreak: 'break-word', lineHeight: 1.25 }}>
                {primeiroValor(execucao.resumoAgendamento?.titulo, execucao.resumoAgendamento?.subtitulo) || `${nomeFormulario}: ${execucao.identificador}`}
              </Typography>
              {/* Prazo/status ocultado temporariamente: exibe textos como "em cerca de 24 horas" e "há 7 dias". */}
              {/* {renderStatus(execucao.status, execucao.dataPrevista)} */}
            </Stack>
            <Stack spacing={0.25}>
              {detalhes.map(([rotulo, valor]) => <Typography key={rotulo} variant="body2" sx={{ wordBreak: 'break-word', lineHeight: 1.25 }}>
                {rotulo && <Box component="span" fontWeight="bold">{rotulo}: </Box>}{valor}
              </Typography>)}
            </Stack>
          </Box>
          {isEditing && (
            <Stack padding={1} spacing={1}>
              <Autocomplete
                disablePortal
                value={selectedUnidade ? { nome: 'a', id: selectedUnidade } : null}
                options={unidadesData ?? []}
                onChange={(_, newValue) => setSelectedUnidade(newValue?.id || null)}
                onOpen={() => getUnidades()}
                getOptionLabel={(option) => option?.nome ?? ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => <TextField {...params} label="Unidade" />}
                renderOption={(props, option) => (<li {...props} key={option.id}> {option.nome} </li>)}
              />
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                <DesktopDatePicker format='dd/MM/yyyy'
                  value={date}
                  minDate={new Date()}
                  onChange={(newValue) => {
                    if (newValue) {
                      newValue.setHours(0, 0, 0, 0);
                      setDate(newValue);
                    } else {
                      setDate(null);
                    }
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                    },
                    actionBar: {
                      actions: ['clear'],
                    },
                    field: {
                      readOnly: true,
                    },
                  }} />
              </LocalizationProvider>
              <Box display={'flex'} justifyContent={'flex-end'} gap={1}>
                <Button variant="outlined" color="primary" size="large" sx={{ width: '100%' }} onClick={() => handleCancelEdit(execucao.id)}>
                  {t('cancel')}
                </Button>
                <Button loading={isSaving} variant="contained" color="primary" size="large" sx={{ width: '100%' }} onClick={() => droppableId && updateFirestore(execucao.id, droppableId, selectedUnidade, date ? date?.getTime() : null)}>
                  {t('save')}
                </Button>
              </Box>
            </Stack>
          )}
        </Box>
      )}
    </Draggable>
  );
};

export default React.memo(AccomplishCard);
